import { render, staticRenderFns } from "./RulesPage.vue?vue&type=template&id=c2857c9a&scoped=true"
import script from "./RulesPage.vue?vue&type=script&lang=js"
export * from "./RulesPage.vue?vue&type=script&lang=js"
import style0 from "./RulesPage.vue?vue&type=style&index=0&id=c2857c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2857c9a",
  null
  
)

export default component.exports